import { UI_SP_CLIENT_ID, UI_SP_TENANT_ID } from "../configs";

export const msalConfig = {
  auth: {
    clientId: UI_SP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${UI_SP_TENANT_ID}/v2.0`,
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/`,
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

export const loginRequest = {
  scopes: [`${UI_SP_CLIENT_ID}/.default`],
};
